import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from "dayjs";
import { orderBy } from "lodash";
import { Bar } from "@antv/g2plot";
export default {
  name: "OperationChart",
  props: {},
  data: function data() {
    return {
      houseAuditTimeType: 1,
      loading: false,
      houseAuditBar: null
    };
  },
  mounted: function mounted() {},
  methods: {
    getHouseAuditCount: function getHouseAuditCount() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve, reject) {
                  var start, end, res;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _this.loading = true;
                        console.log(1);
                        start = dayjs().format("YYYY-MM-DD");
                        end = dayjs().format("YYYY-MM-DD");
                        if (_this.houseAuditTimeType == 1) {
                          start = dayjs().subtract(1, "week").format("YYYY-MM-DD");
                        } else if (_this.houseAuditTimeType == 2) {
                          start = dayjs().subtract(1, "month").format("YYYY-MM-DD");
                        } else if (_this.houseAuditTimeType == 3) {
                          start = dayjs().subtract(3, "month").format("YYYY-MM-DD");
                        } else if (_this.houseAuditTimeType == 4) {
                          start = dayjs().subtract(6, "month").format("YYYY-MM-DD");
                        }
                        _context.n = 1;
                        return _this.$api.getChartData({
                          chart_name: "audit_house_total",
                          grain: "day",
                          start: start,
                          end: end
                        });
                      case 1:
                        res = _context.v;
                        _this.loading = false;
                        resolve(true);
                        console.log(_this.loading, 'loadingloadingloading');
                        res.data.forEach(function (item) {
                          var values = item.value.split("/");
                          item.pass = values[0];
                          item.value = parseInt(values[1]);
                          // item.name += "-";
                          // item.name += ((item.pass / item.value) * 100).toFixed(1) + "%";
                        });
                        res.data = orderBy(res.data, ["value"], ["desc"]);
                        if (_this.houseAuditBar) {
                          _this.houseAuditBar.changeData(res.data);
                        } else {
                          _this.houseAuditBar = new Bar("container-house-audit", {
                            data: res.data,
                            legend: {
                              position: "top-left",
                              offsetY: 70
                            },
                            // seriesField: "name",
                            smooth: true,
                            appendPadding: [70, 0, 0, 0],
                            xField: "value",
                            yField: "name",
                            barWidthRatio: 0.8,
                            meta: {
                              name: {
                                alias: "审核人员"
                              },
                              value: {
                                alias: "审核量"
                              },
                              pass: {
                                alias: "通过量"
                              }
                            }
                          });
                          _this.houseAuditBar.render();
                        }
                        _this.getAnalysisAuditHouseErrorRate(res.data, start, end);
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee2);
      }))();
    },
    getAnalysisAuditHouseErrorRate: function getAnalysisAuditHouseErrorRate(data, start, end) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this2.$api.getAnalysisAuditHouseErrorRate({
                grain: "day",
                start: start,
                end: end
              });
            case 1:
              res = _context3.v;
              res.data.forEach(function (item) {
                data.forEach(function (i) {
                  if (item.name == i.name) {
                    i.name += "-" + item.value;
                  }
                });
              });
              _this2.houseAuditBar.changeData(data);
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};